export const supplementaryInitialState = {
    messageTypes: [],
};
